module.exports = __webpack_public_path__ + "static/media/DooExchangeFooterColor.a8326729.svg";